// import get from 'lodash/get';
import { handleError } from 'helper/rest';
import { client } from 'helper/axios';
// import { setCookie } from 'helper/cookie';
// import { parseJWT } from 'helper/jwt';
// import Swal from 'sweetalert2';
// import Color from 'constants/color.constants';

export const getThrustAll = async ({ token, params }: any) => {
  try {
    return await client
      .get(`thrust`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      })
      .then(response => {
        return response;
      })
      .catch(error => {
        const { response } = error;
        handleError(response);
        return response;
      });
  } catch (error) {
    console.error('error', error);
    return error;
  }
};

export const postCreateThrust = async ({ token, params }: any) => {
  try {
    return await client
      .post(`thrust`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(response => {
        return response;
      })
      .catch(error => {
        const { response } = error;
        handleError(response);
        return response;
      });
  } catch (error) {
    console.error('error', error);
    return error;
  }
};

export const deleteThrust = async ({ token, id, params }: any) => {
  try {
    return await client
      .delete(`thrust/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      })
      .then(response => {
        return response;
      })
      .catch(error => {
        const { response } = error;
        handleError(response);
        return response;
      });
  } catch (error) {
    console.error('error', error);
    return error;
  }
};

export const postExportThrustPDF = async ({ token, params }: any) => {
  try {
    return await client
      .post(`thrust_export_pdf`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: 'blob', // ระบุว่า response ที่คาดหวังคือ blob
      })
      .then(response => {
        // Create a URL from the Blob to open/download the PDF
        const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
        // Create a URL from the Blob to open/download the PDF

        // Optionally, open the PDF in a new tab for preview
        window.open(url, '_blank');

        // Create a link to download the file
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `นำข้อมูลออกโพยที่_${params.thrust_no}_เลขงวด${params.period_id}ประเภทหวย${params.lottery_name}.pdf`); // Name the file
        document.body.appendChild(link);
        link.click();

        // Clean up by removing the link and revoking the URL
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        return response;
      })
      .catch(error => {
        const { response } = error;
        handleError(response);
        return response;
      });
  } catch (error) {
    console.error('error', error);
    return error;
  }
};

export const postExportThrustPDFALL = async ({ token, params }: any) => {
  try {
    return await client
      .post(`thrust_export_pdf_all`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: 'blob', // ระบุว่า response ที่คาดหวังคือ blob
      })
      .then(response => {
        // Create a URL from the Blob to open/download the PDF
        const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
        // Create a URL from the Blob to open/download the PDF

        // Optionally, open the PDF in a new tab for preview
        window.open(url, '_blank');

        // Create a link to download the file
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `นำข้อมูล_เลขงวด${params.period_id}ประเภทหวย${params.lottery_name}.pdf`); // Name the file
        document.body.appendChild(link);
        link.click();

        // Clean up by removing the link and revoking the URL
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        return response;
      })
      .catch(error => {
        const { response } = error;
        handleError(response);
        return response;
      });
  } catch (error) {
    console.error('error', error);
    return error;
  }
};

export const postExportThrustExcel = async ({ token, params }: any) => {
  try {
    return await client
      .post(`thrust_export_excel`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: 'blob', // ระบุว่า response ที่คาดหวังคือ blob
      })
      .then(response => {
        // console.log(response)
        // console.log(params)
        // const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/excel' }));
        // window.open(url, '_blank');

        const url = window.URL.createObjectURL(
          new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }),
        );
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `นำข้อมูลออกโพยที่_${params.thrust_no}_เลขงวด${params.period_id}_ประเภทหวย${params.lottery_name}.xlsx`); // ตั้งชื่อไฟล์ที่ดาวน์โหลด
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url); // คืนทรัพยากร URL

        return response;
      })
      .catch(error => {
        const { response } = error;
        handleError(response);
        return response;
      });
  } catch (error) {
    console.error('error', error);
    return error;
  }
};

export const deleteThrustPoi = async ({ token, id, params }: any) => {
  try {
    return await client
      .delete(`thrust_poi`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      })
      .then(response => {
        return response;
      })
      .catch(error => {
        const { response } = error;
        handleError(response);
        return response;
      });
  } catch (error) {
    console.error('error', error);
    return error;
  }
};

export const deleteThrustNotiPoi = async ({ token, id, params }: any) => {
  try {
    return await client
      .delete(`thrust_noti_poi`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      })
      .then(response => {
        return response;
      })
      .catch(error => {
        const { response } = error;
        handleError(response);
        return response;
      });
  } catch (error) {
    console.error('error', error);
    return error;
  }
};

export const postThrustSummaryPeriod = async ({ token, params }: any) => {
  try {
    return await client
      .post(`thrust_summary_period`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(response => {
        return response;
      })
      .catch(error => {
        const { response } = error;
        handleError(response);
        return response;
      });
  } catch (error) {
    console.error('error', error);
    return error;
  }
};

export const getThrustNotiDeleteAll = async ({ token, params }: any) => {
  try {
    return await client
      .get(`thrust_noti_delete_all`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      })
      .then(response => {
        return response;
      })
      .catch(error => {
        const { response } = error;
        handleError(response);
        return response;
      });
  } catch (error) {
    console.error('error', error);
    return error;
  }
};

export const getThrustNotiDeleteCountAll = async ({ token, params }: any) => {
  try {
    return await client
      .get(`thrust_noti_delete_count_all`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      })
      .then(response => {
        return response;
      })
      .catch(error => {
        const { response } = error;
        handleError(response);
        return response;
      });
  } catch (error) {
    console.error('error', error);
    return error;
  }
};

export const deleteThrustOwnerNotiPoi = async ({ token, params }: any) => {
  try {
    return await client
      .delete(`thrust_owner_noti_poi`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      })
      .then(response => {
        return response;
      })
      .catch(error => {
        const { response } = error;
        handleError(response);
        return response;
      });
  } catch (error) {
    console.error('error', error);
    return error;
  }
};

export const postThrustCutPriceOne = async ({ token, params }: any) => {
  try {
    return await client
      .post(`thrust_cut_price_one`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(response => {
        return response;
      })
      .catch(error => {
        const { response } = error;
        handleError(response);
        return response;
      });
  } catch (error) {
    console.error('error', error);
    return error;
  }
};

export const postThrustCutPriceByUser = async ({ token, params }: any) => {
  try {
    return await client
      .post(`thrust_cut_price_by_user`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(response => {
        return response;
      })
      .catch(error => {
        const { response } = error;
        handleError(response);
        return response;
      });
  } catch (error) {
    console.error('error', error);
    return error;
  }
};

export const postThrustCutPriceByDealer = async ({ token, params }: any) => {
  try {
    return await client
      .post(`thrust_cut_price_by_dealer`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(response => {
        return response;
      })
      .catch(error => {
        const { response } = error;
        handleError(response);
        return response;
      });
  } catch (error) {
    console.error('error', error);
    return error;
  }
};

export const getCutDealerAll = async ({ token, params }: any) => {
  try {
    return await client
      .get(`thrust_get_cut_dealer`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      })
      .then(response => {
        return response;
      })
      .catch(error => {
        const { response } = error;
        handleError(response);
        return response;
      });
  } catch (error) {
    console.error('error', error);
    return error;
  }
};

export const deleteCutDealer = async ({ token, params }: any) => {
  try {
    return await client
      .delete(`thrust_get_cut_dealer_delete`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      })
      .then(response => {
        return response;
      })
      .catch(error => {
        const { response } = error;
        handleError(response);
        return response;
      });
  } catch (error) {
    console.error('error', error);
    return error;
  }
};
